<template>
  <div class="app">
    <hospital-select @selected="selectHospital"></hospital-select>
    <voucher-select
      :list="voucherList"
      @selected="selectVoucher"
    ></voucher-select>
    <div class="dept-list" v-for="(item, index) in inpatientList">
      <div class="dept-name">
        <span>{{ item.deptName }}</span>
        <span
          :class="{
            blue: item.signState == '已预约',
            gray: item.signState == '已取消',
            green: item.signState == '已入院',
          }"
          >{{ item.signState }}</span
        >
      </div>
      <div class="dept-doctor" @click="goDetails(index)">
        <div>开入院证时间:{{ item.inTime }}</div>
      </div>
    </div>
    <no-record
      id="myregister-norecord"
      :condition="inpatientList"
      tips="抱歉，没有住院记录"
    ></no-record>
  </div>
</template>

<script>
import queryVoucher from 'voucher.service'
import inpatientDetails from 'inpatientRecharge.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import NoRecord from 'NoRecord'
export default {
  components: {
    HospitalSelect,
    NoRecord,
    VoucherSelect
  },
  data () {
    return {
      voucher: {
        cardNo: '',
        cardType: '',
        holderName: '',
        hospitalName: ''
      },
      voucherList: [],
      inpatientList: [],
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    }
  },
  mounted () {
    this.messagePush();
  },
  methods: {
    messagePush () {
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.cardNo) {
        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        window.http.headers.common['hospitalId'] = hospital.hospitalId;
      }
      this.loadVouchers();
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    refresh () {
      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) == "undefined") {
        this.$utils.alert("请选择医院");
        return
      }
      //处理未绑定就诊凭证
      if (!this.voucher.cardType || !this.voucher.cardNo) {
        return this.$utils.alert('请先绑定诊疗卡')
      }
      this.loadRegister()
    },
    //选择就诊凭证
    selectVoucher (v) {
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v
      });
      //加载默认卡的就诊记录列表
      this.refresh();
    },
    //选择医院
    selectHospital () {
      this.refresh();
    },
    loadRegister () {
      inpatientDetails.loadDetail({
        cardNo: this.voucher.cardNo,
        cardType: this.voucher.cardType
      }).then((res) => {
        this.inpatientList = res.data
        for (var i = 0; i < this.inpatientList.length; i++) {
          if (!this.inpatientList[i].inTime) {
            this.inpatientList[i].inTime = ''
            this.inpatientList[i].signState = this.transStateStr(this.inpatientList[i].status)
            return
          }
          let inTime = this.inpatientList[i].inTime
          let dateObject = new Date(inTime.replace(/-/g, '/'))
          let week = dateObject.getDay()
          this.inpatientList[i].inTime = dateObject.format('yyyy/MM/dd hh:mm').split(' ').join(' ' + this.weekday[week] + ' ')
          this.inpatientList[i].signState = this.transStateStr(this.inpatientList[i].status)
        }
      })
    },
    transStateStr (state) {
      if (!state && state !== 0) {
        state = ''
      }
      switch (state) {
        case '':
          return '已取消'
        case '1':
          return '已预约'
        case '2':
          return '已入院'
        case '3':
          return '已入院'
        case '4':
          return '已入院'
      }
    },
    goDetails (index) {
      localStorage.setItem('inpatientList', JSON.stringify(this.inpatientList[index]))
      this.$router.push({
        name: 'InpatientDetails',
        query: {
          hospitalName: this.voucher.hospitalName,
          cardNo: this.voucher.cardNo,
          cardType: this.voucher.cardType
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.app {
  background-color: #eff3f6;
  .more {
    position: relative;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    font-size: 0.65rem;
    .btn-ok {
      position: absolute;
      width: 2.5rem;
      height: 1.5rem;
      right: 0.2rem;
      font-size: 0.65rem;
    }
  }
  .dept-list {
    background-color: #fff;
    margin: 0.5rem 0;
    .dept-name {
      padding: 0.3rem 0.875rem;
      border-bottom: 0.05rem solid #eff3f6;
      height: 2rem;
      line-height: 2rem;
      display: flex;
      justify-content: space-between;
      .blue {
        color: #1fa9f0;
      }
      .gray {
        color: #999999;
      }
      .green {
        color: #57d3ba;
      }
    }
    .dept-doctor {
      padding: 0.5rem 0.875rem;
      color: #999999;
      div {
        padding: 0.5rem 0;
      }
      div:nth-child(1) {
        position: relative;
      }
      div:nth-child(1):before {
        position: absolute;
        content: "";
        width: 0.425rem;
        height: 0.675rem;
        top: 50%;
        right: 0;
        margin-top: -0.335rem;
        background: url(../../../static/img/more-arrow.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// InpatientRegister.vue?686bc6de